// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2bWAQ","expireSoon":"styles_expireSoon__2tNsU"};